export class UserSessionDto {
  FirstName: string = "";
  LastName: string = "";
  Username: string = "";
  UserId: string = "";
  Email: string = "";
}
